import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "../../local_icons/arrow.svg";

const ArrowButton = ({
  text = "",
  external_link = "",
  iconColor = "var(--white)",
  onClick = undefined,
  iconSize = "1rem",
  padding = "1rem",
  ...props
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <a
      style={{
        ...styles.buttonContainer,
      }}
      onMouseOver={(e) => setIsHovering(true)}
      onMouseOut={(e) => setIsHovering(false)}
      target="_blank"
      href={external_link}
    >
      <p style={{ ...styles.text, ...props }}>{text}</p>
      <div style={{ ...styles.iconContainer, padding: padding }}>
        <ArrowIcon
          style={{
            width: iconSize,
            height: iconSize,
            color: iconColor,
            transition: "all 0.5s ease",
          }}
        />
      </div>
    </a>
  );
};

const styles: Record<string, React.CSSProperties> = {
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid var(--black)",
    cursor: "pointer",
    color:"var(--black)",
    textDecoration:"none",
  },
  text: {
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "0.75rem 1.5rem",
    width: "100%",
    textDecoration:"none",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--black)",
    height: "100%",
    padding: "1rem",
    textDecoration:"none",
  },
};

export default ArrowButton;
